/* SupportDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Fieldset } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import { H2 } from '@atlassian/mpac-primitives';
import { TextInput } from '@atlassian/mpac-ui';
import { SlaHelper } from '../HelpText';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _9 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _8 = "@media (min-width:48rem){._14b5jvo9{width:40rem}}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "@media (min-width:48rem){._6ytt47zb{padding:var(--_o3usm9)}}";
const _3 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _2 = "._otyridpf{margin-bottom:0}";
const _ = "._1yt4zmd4{padding:var(--_1aun1c5)}";
const FieldsetTitleH2 = null;
const LeftPadding = null;
const FieldWidth20 = null;
const FieldWidth40 = null;
export const SupportDetails = _ref => {
  let {
    submissionErrors
  } = _ref;
  return /*#__PURE__*/_jsx(Fieldset, {
    legend: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4]
      }), /*#__PURE__*/_jsx(H2, {
        className: ax(["_1yt4zmd4 _otyridpf _k48p1wq8 _6ytt47zb"]),
        style: {
          "--_1aun1c5": ix("var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
          "--_o3usm9": ix("var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-025, 2px)"))
        },
        children: "Support details"
      })]
    }),
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_5, _6]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5jvo9"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "emergencyContact",
              label: "24/7 emergency contact details",
              width: "100%",
              helperMessage: "Enter an email address and phone number where Atlassian Support can reach you during emergencies.",
              fieldType: "textarea",
              testId: "emergency-contact-input",
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.emergencyContact
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _9]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "slaStatementUrl",
              label: "SLA statement URL",
              width: "100%",
              helperMessage: SlaHelper,
              type: "url",
              testId: "sla-statement-url-input",
              applyDefaultValidation: true,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.slaStatementUrl
            })
          })]
        })]
      })]
    })
  });
};